// A1 - Ünite 2: Present Simple - Olumsuz ve Soru
// Hedef: Don't/Doesn't, Do/Does ile soru yapma, WH sorular

export const A1_UNIT_2 = {
  'A1-U2-L1': {
    id: 'A1-U2-L1',
    title: "I don't + fiil",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Simple Olumsuz - I/You/We/They',
          explanation: 'Olumsuz cümle yapmak için özne ile fiil arasına "do not" (kısaca don\'t) eklenir. Fiil kök halinde kalır!',
          table: {
            headers: ['Özne', 'Yardımcı', 'Fiil', 'Örnek'],
            rows: [
              ['I', "don't", 'work', "I don't work on Sundays."],
              ['You', "don't", 'fly', "You don't fly domestic routes."],
              ['We', "don't", 'serve', "We don't serve alcohol."],
              ['They', "don't", 'check', "They don't check bags here."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '⚠️ Önemli Kural',
          explanation: 'Olumsuz cümlede fiil HER ZAMAN kök haliyle kalır. -s/-es EKLENMEZ!',
          table: {
            headers: ['Yanlış ❌', 'Doğru ✓'],
            rows: [
              ["I don't works", "I don't work"],
              ["We don't flies", "We don't fly"],
              ["They don't checks", "They don't check"]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "I don\'t have experience but..." gibi yapılar kullanışlıdır!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Olumsuz Cümlelerde Sık Kullanılan Kelimeler',
          words: [
            { en: 'yet', tr: 'henüz', pronunciation: '/jet/' },
            { en: 'anymore', tr: 'artık', pronunciation: '/ˌeniˈmɔːr/' },
            { en: 'either', tr: 'de/da (olumsuzda)', pronunciation: '/ˈaɪðər/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ work on weekends.',
          options: ["don't", "doesn't", 'not', "don't not"],
          correct: "don't",
          explanation: 'I ile don\'t kullanılır'
        },
        {
          type: 'multipleChoice',
          question: "We _____ alcohol on this airline.",
          options: ["don't serve", "doesn't serve", "don't serves", "not serve"],
          correct: "don't serve",
          explanation: "We ile don't + fiil kök hali"
        },
        {
          type: 'fillInBlank',
          sentence: "They _____ (not/fly) to that destination.",
          answer: "don't fly",
          hint: "They ile don't + fiil kök hali"
        },
        {
          type: 'matching',
          instruction: 'Olumlu ve olumsuz formları eşleştirin',
          pairs: [
            { left: 'I work', right: "I don't work" },
            { left: 'We fly', right: "We don't fly" },
            { left: 'They serve', right: "They don't serve" },
            { left: 'You check', right: "You don't check" }
          ]
        }
      ]
    }
  },
  'A1-U2-L2': {
    id: 'A1-U2-L2',
    title: "He/She doesn't + fiil",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Simple Olumsuz - He/She/It',
          explanation: '3. tekil şahıs için "does not" (kısaca doesn\'t) kullanılır. Fiil kök halinde kalır - -s/-es EKLENMEZ!',
          table: {
            headers: ['Özne', 'Yardımcı', 'Fiil', 'Örnek'],
            rows: [
              ['He', "doesn't", 'work', "He doesn't work today."],
              ['She', "doesn't", 'fly', "She doesn't fly tomorrow."],
              ['It', "doesn't", 'take', "It doesn't take long."],
              ['The plane', "doesn't", 'land', "The plane doesn't land here."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '⚠️ En Yaygın Hata',
          explanation: 'Olumsuz cümlede fiil kök haliyle kalır. -s/-es sadece olumlu cümlede kullanılır!',
          table: {
            headers: ['Yanlış ❌', 'Doğru ✓', 'Açıklama'],
            rows: [
              ["She doesn't works", "She doesn't work", "doesn't zaten 3. tekil şahsı gösterir"],
              ["He doesn't flies", "He doesn't fly", "fiil kök haliyle kalır"],
              ["It doesn't goes", "It doesn't go", "-s eklenmez"]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Olumlu: She works ✓ | Olumsuz: She doesn\'t work ✓ (works DEĞİL!)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ work on this flight.',
          options: ["don't", "doesn't", "not", "doesn't not"],
          correct: "doesn't",
          explanation: 'She ile doesn\'t kullanılır'
        },
        {
          type: 'multipleChoice',
          question: "He _____ international flights.",
          options: ["doesn't flies", "doesn't fly", "don't fly", "not fly"],
          correct: "doesn't fly",
          explanation: "He ile doesn't + fiil kök hali"
        },
        {
          type: 'fillInBlank',
          sentence: "The captain _____ (not/have) much time.",
          answer: "doesn't have",
          hint: "The captain (3. tekil) ile doesn't + have"
        },
        {
          type: 'fillInBlank',
          sentence: "She _____ (not/speak) French.",
          answer: "doesn't speak",
          hint: "She ile doesn't + fiil kök hali"
        }
      ]
    }
  },
  'A1-U2-L3': {
    id: 'A1-U2-L3',
    title: 'Do you...? Does she...?',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Simple Soru',
          explanation: 'Soru yapmak için cümlenin başına Do veya Does getirilir. Fiil kök haliyle kalır.',
          table: {
            headers: ['Yardımcı', 'Özne', 'Fiil', 'Örnek'],
            rows: [
              ['Do', 'I/you/we/they', 'work?', 'Do you work here?'],
              ['Does', 'he/she/it', 'work?', 'Does she work here?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 Soru ve Cevap Kalıpları',
          table: {
            headers: ['Soru', 'Kısa Cevap (Evet)', 'Kısa Cevap (Hayır)'],
            rows: [
              ['Do you speak English?', 'Yes, I do.', "No, I don't."],
              ['Does she fly international?', 'Yes, she does.', "No, she doesn't."],
              ['Do they serve food?', 'Yes, they do.', "No, they don't."]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta soru sorulduğunda kısa cevap verin, ardından açıklama yapın: "Yes, I do. I speak English fluently."'
        },
        {
          type: 'vocabulary',
          title: '✈️ Mülakat Soruları',
          words: [
            { en: 'Do you have experience?', tr: 'Deneyiminiz var mı?', pronunciation: '' },
            { en: 'Do you speak any languages?', tr: 'Herhangi bir dil konuşuyor musunuz?', pronunciation: '' },
            { en: 'Does this job interest you?', tr: 'Bu iş ilginizi çekiyor mu?', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ you speak English?',
          options: ['Do', 'Does', 'Are', 'Is'],
          correct: 'Do',
          explanation: 'You ile Do kullanılır'
        },
        {
          type: 'multipleChoice',
          question: '_____ she work for Turkish Airlines?',
          options: ['Do', 'Does', 'Is', 'Are'],
          correct: 'Does',
          explanation: 'She ile Does kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ they serve meals on this flight?',
          answer: 'Do',
          hint: 'They ile Do kullanılır'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'Do you work here?', right: 'Yes, I do.' },
            { left: 'Does she fly often?', right: 'Yes, she does.' },
            { left: 'Do they speak Turkish?', right: "No, they don't." }
          ]
        }
      ]
    }
  },
  'A1-U2-L4': {
    id: 'A1-U2-L4',
    title: 'WH Sorular (What, Where, When...)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 WH Soru Kelimeleri',
          explanation: 'WH soru kelimeleri ile daha detaylı bilgi alınır. Yapı: WH + do/does + özne + fiil?',
          table: {
            headers: ['WH Kelimesi', 'Türkçesi', 'Örnek'],
            rows: [
              ['What', 'Ne', 'What do you do?'],
              ['Where', 'Nerede', 'Where does she work?'],
              ['When', 'Ne zaman', 'When do they arrive?'],
              ['Why', 'Neden', 'Why do you want this job?'],
              ['How', 'Nasıl', 'How does he fly?'],
              ['Who', 'Kim', 'Who works here?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık WH Soruları',
          table: {
            headers: ['Soru', 'Türkçesi', 'Örnek Cevap'],
            rows: [
              ['What time does the flight depart?', 'Uçuş saat kaçta kalkıyor?', 'It departs at 10 AM.'],
              ['Where does this flight go?', 'Bu uçuş nereye gidiyor?', 'It goes to Istanbul.'],
              ['How long does the flight take?', 'Uçuş ne kadar sürüyor?', 'It takes 3 hours.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Who" ile soru yapılırken do/does KULLANILMAZ: Who works here? (Kim burada çalışıyor?)'
        },
        {
          type: 'vocabulary',
          title: '✈️ Mülakat WH Soruları',
          words: [
            { en: 'Why do you want to be a cabin crew?', tr: 'Neden kabin ekibi olmak istiyorsunuz?', pronunciation: '' },
            { en: 'What do you know about our airline?', tr: 'Havayolumuz hakkında ne biliyorsunuz?', pronunciation: '' },
            { en: 'Where do you see yourself in 5 years?', tr: '5 yıl sonra kendinizi nerede görüyorsunuz?', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ do you want this job?',
          options: ['What', 'Where', 'Why', 'When'],
          correct: 'Why',
          explanation: 'Why = Neden'
        },
        {
          type: 'multipleChoice',
          question: '_____ does the flight arrive?',
          options: ['What', 'When', 'Why', 'Who'],
          correct: 'When',
          explanation: 'When = Ne zaman'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ does she work? - At the airport.',
          answer: 'Where',
          hint: 'Cevap yer bildiriyor'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'What do you do?', right: 'I am a student.' },
            { left: 'Where does he work?', right: 'At the airport.' },
            { left: 'When does the flight leave?', right: 'At 9 PM.' },
            { left: 'Why do you apply?', right: 'Because I love aviation.' }
          ]
        }
      ]
    }
  },
  'A1-U2-L5': {
    id: 'A1-U2-L5',
    title: 'Uygulama: Yolcuya Soru Sorma',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Yolculara Sorulabilecek Sorular',
          explanation: 'Kabin memuru olarak yolculara sık sorulan sorular:',
          table: {
            headers: ['Soru', 'Türkçesi', 'Durum'],
            rows: [
              ['Do you need any help?', 'Yardıma ihtiyacınız var mı?', 'Genel yardım'],
              ['Would you like something to drink?', 'İçecek ister misiniz?', 'İkram'],
              ['Does this seat work for you?', 'Bu koltuk size uyar mı?', 'Koltuk'],
              ['Do you have any questions?', 'Herhangi bir sorunuz var mı?', 'Bilgi']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 Yolcu Bilgisi Alma',
          table: {
            headers: ['Soru', 'Amaç'],
            rows: [
              ['What is your seat number?', 'Koltuk numarası öğrenme'],
              ['Where do you fly to?', 'Varış noktası öğrenme'],
              ['Do you have any special requirements?', 'Özel ihtiyaç kontrolü'],
              ['Does your child need anything?', 'Çocuk ihtiyaç kontrolü']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Yolculara her zaman nazik ve profesyonel sorular sorun. "Excuse me" ile başlayın.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Excuse me, _____ you need any assistance?',
          options: ['do', 'does', 'are', 'is'],
          correct: 'do',
          explanation: 'You ile do kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ your child have any allergies?',
          answer: 'Does',
          hint: 'Your child (3. tekil) ile Does'
        },
        {
          type: 'fillInBlank',
          sentence: 'What _____ (do/you/prefer), tea or coffee?',
          answer: 'do you prefer',
          hint: 'WH + do + özne + fiil'
        },
        {
          type: 'speaking',
          instruction: 'Şu durumlar için soru oluşturun:',
          phrases: [
            'Ask if they want a drink',
            'Ask where they are traveling',
            'Ask if they need help',
            'Ask about special meals'
          ]
        }
      ]
    }
  },
  'A1-U2-EXAM': {
    id: 'A1-U2-EXAM',
    title: 'Ünite 2 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: "I _____ work on Sundays.",
        options: ["don't", "doesn't", 'not', 'no'],
        correct: "don't",
        explanation: 'I ile don\'t kullanılır'
      },
      {
        type: 'multipleChoice',
        question: "She _____ speak German.",
        options: ["don't", "doesn't", "not", "doesn't not"],
        correct: "doesn't",
        explanation: 'She ile doesn\'t kullanılır'
      },
      {
        type: 'multipleChoice',
        question: '_____ you have any experience?',
        options: ['Do', 'Does', 'Are', 'Is'],
        correct: 'Do',
        explanation: 'You ile Do kullanılır'
      },
      {
        type: 'multipleChoice',
        question: '_____ does the flight depart?',
        options: ['What', 'When', 'Why', 'Who'],
        correct: 'When',
        explanation: 'When = Ne zaman'
      },
      {
        type: 'fillInBlank',
        sentence: "He _____ (not/fly) domestic routes.",
        answer: "doesn't fly",
        hint: "He ile doesn't + fiil kök hali"
      },
      {
        type: 'fillInBlank',
        sentence: '_____ do you want to work for us?',
        answer: 'Why',
        hint: 'Sebep soruluyor'
      },
      {
        type: 'matchPairs',
        instruction: 'Soruları cevaplarla eşleştirin',
        pairs: [
          { left: 'Do you speak English?', right: 'Yes, I do.' },
          { left: 'Does she work here?', right: 'No, she doesn\'t.' },
          { left: 'What do you do?', right: 'I am a student.' }
        ]
      }
    ]
  }
};

export default A1_UNIT_2;
